export const STORAGE = {
    CREDENTIALS_KEY: 'credentials',
    ACCESS_TOKEN_KEY: 'access_token',
    REFRESH_TOKEN_KEY: 'refresh_token',
    ID_TOKEN_KEY: 'id_token',
  };
  